"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_state_manager_1 = require("./global-state-manager");
exports.default = new global_state_manager_1.default();
